/**
 * Created by zhayuechao on 2018/07/18.
 */
'use strict'

import store from '../store'

// 小数过滤为百分比
const filterPercent = (value) => {
  if (!value) {
    return ''
  }
  if (value) return (value * 100).toFixed(2) + '%'
}

const formatUtil = (value) => {
  return value === 1 ? '￥' : ''
}

export {
  filterPercent,
  formatUtil
}
